document.addEventListener('DOMContentLoaded', () => {
    if (window.reviewIntervals) {
        window.reviewIntervals.forEach(clearInterval);
    }
    window.reviewIntervals = [];

    const holders = document.querySelectorAll('.ticker-holder');

    holders.forEach((holder) => {
        const reviews = Array.from(holder.querySelectorAll('.ticker-container'));

        if (reviews.length === 0) return;

        reviews.forEach((r) => r.classList.remove('active'));
        reviews[0].classList.add('active');

        let index = 0;

        const interval = setInterval(() => {
            reviews[index].classList.remove('active');
            index = (index + 1) % reviews.length;
            reviews[index].classList.add('active');
        }, 7000);

        window.reviewIntervals.push(interval);
    });
});